import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";

const currency = (value) => {
  if (value === null || value === undefined || value === "") return "Não informado";
  const amount = typeof value === "number" ? value : Number(
    String(value).includes(",")
      ? String(value).replace(/[^\d,-]/g, "").replace(",", ".")
      : value,
  );
  return Number.isFinite(amount)
    ? amount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : "Não informado";
};

export default function AnttValidationModal({ alert, onClose, onConfirm, loading = false }) {
  const isDriver = alert?.type === "driver";
  const label = isDriver ? "Valor anunciado" : "Valor do frete";
  return (
    <Dialog open={Boolean(alert)} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm" aria-labelledby="antt-alert-title" PaperProps={{ sx: { borderRadius: 3, p: 2 } }}>
      <DialogTitle id="antt-alert-title" sx={{ color: "#012443", fontWeight: 700, display: "flex", alignItems: "center", gap: 2, pr: 5 }}>
        <ErrorIcon sx={{ color: "#cf182b", fontSize: 44 }} />
        {isDriver ? "Valor anunciado abaixo do piso ANTT" : "Frete abaixo do piso ANTT"}
      </DialogTitle>
      <IconButton aria-label="Fechar alerta ANTT" onClick={onClose} disabled={loading} sx={{ position: "absolute", right: 12, top: 12 }}><CloseIcon /></IconButton>
      <DialogContent>
        <Typography sx={{ mb: 3 }}>
          {isDriver ? "O valor anunciado está" : "O valor do frete está"} abaixo do mínimo permitido pela ANTT. Ajuste o valor para continuar.
        </Typography>
        {alert?.message && <Typography sx={{ mb: 2, color: "text.secondary" }}>{alert.message}</Typography>}
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2, bgcolor: "#fcebed", borderRadius: 2, p: 2.5 }}>
          <Box><Typography>{label}</Typography><Typography sx={{ fontSize: 24, fontWeight: 700, color: "#bb1c2b" }}>{currency(alert?.proposedValue)}</Typography></Box>
          <Box><Typography>Mínimo ANTT (com pedágio)</Typography><Typography sx={{ fontSize: 24, fontWeight: 700, color: "#012443" }}>{currency(alert?.minimum)}</Typography></Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button fullWidth variant="outlined" onClick={onClose} disabled={loading} sx={{ py: 1.5 }}>Voltar</Button>
        <Button fullWidth variant="contained" onClick={onConfirm} disabled={loading} sx={{ py: 1.5, bgcolor: "#012443" }}>Usar piso ANTT</Button>
      </DialogActions>
    </Dialog>
  );
}
